// src/pages/Home.jsx
import React from "react";
import Navbar from "../component/Navbar";
import CouncilMembers from "../component/ParmMember";
import UpcomingEvents from "../component/CardsEvents";
import Footer from "../component/Footer";
import Slider from "../component/Slider_Homepage";
import EventCard from "../component/CardsEvents";
import AboutUs from "../component/AboutUs_Homepage";
import RegisteredCompanies from "../component/RegisteredCompany";
import Merchandise from "../component/ParmMerchandise";
import ExploreEvent from "../component/ExploreEvent";
import ParmMagazines from "../component/ParmMagazine";
import RecentNews from "../component/RecentNews";
import ArboricultureSection from "../component/Arboriculture";
import LandingSection from "../component/BecomeMember";

export default function Home() {
  return (
    <>
      <Slider />
      <EventCard />
      <AboutUs />
      <CouncilMembers />
      {/* <RegisteredCompanies /> */}
      {/* <Merchandise/> */}
      <ExploreEvent/>
      <ParmMagazines/>
      <RecentNews/>
      <ArboricultureSection/>
      <LandingSection/>
    </>
  );
}
